
<h2>policies</h2>
<div class="policies-layout">
  <div class="policies-container box-shadow">
    <div class="categories">
      <div class="category" *ngFor="let category of policyCategories"
           [ngClass]="{'active': selectedPolicyCat === category.id}"
           (click)="selectPolicyCategory(category)">
        <span>{{category.description}}</span>
      </div>
    </div>
    <div class="policies">

      <div *ngIf="selectedPolicyCat === 'busLane'">
        <bus-lane-policy (onSavePolicies)="savePolicies($event)"></bus-lane-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'disabled'">
        <disabled-policy (onSavePolicies)="savePolicies($event)"></disabled-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'dispensation'">
        <dispensation-policy (onSavePolicies)="savePolicies($event)"></dispensation-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'firstContravention'">
        <first-contravention-policy (onSavePolicies)="savePolicies($event)"></first-contravention-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'healthEmergencyBadge'">
        <emergency-badge-policy (onSavePolicies)="savePolicies($event)"></emergency-badge-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'loading'">
        <loading-policy (onSavePolicies)="savePolicies($event)"></loading-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'parkingDisc'">
        <parking-disc-policy (onSavePolicies)="savePolicies($event)"></parking-disc-policy>
      </div>

      <div *ngIf="permitTemplateItems.indexOf(selectedPolicyCat) > -1">
        <permit-template-policy [permitId]="selectedPolicyCat"
                                (onSavePolicies)="savePolicies($event)"></permit-template-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'payByPhoneParking'">
        <pay-parking-policy (onSavePolicies)="savePolicies($event)"></pay-parking-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'concessionsPayment'">
        <concessions-payment-policy (onSavePolicies)="savePolicies($event)"></concessions-payment-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'residents'">
        <resident-policy (onSavePolicies)="savePolicies($event)"></resident-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'visitors'">
        <visitor-policy (onSavePolicies)="savePolicies($event)"></visitor-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'custom'">
        <permit-custom-policy (onSavePolicies)="savePolicies($event)"></permit-custom-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'toilet'">
        <toilet-policy (onSavePolicies)="savePolicies($event)"></toilet-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'concessionsOther'">
        <concessions-other-policy (onSavePolicies)="savePolicies($event)"></concessions-other-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'meters'">
        <meters-policy (onSavePolicies)="savePolicies($event)"></meters-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'ticketMachines'">
        <ticket-machines-policy (onSavePolicies)="savePolicies($event)"></ticket-machines-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'payment'">
        <payment-policy (onSavePolicies)="savePolicies($event)"></payment-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'staff'">
        <staff-policy (onSavePolicies)="savePolicies($event)"></staff-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'stoppingForPassengers'">
        <stopping-passengers-policy (onSavePolicies)="savePolicies($event)"></stopping-passengers-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'timescales'">
        <timescales-policy (onSavePolicies)="savePolicies($event)"></timescales-policy>
      </div>

      <div *ngIf="selectedPolicyCat === 'other'">
        <other-policy (onSavePolicies)="savePolicies($event)"></other-policy>
      </div>
      <div *ngIf="selectedPolicyCat === 'dynamicPolicies' && showDynamicPolicies">
        <app-dynamic-policies></app-dynamic-policies>
      </div>



      <div class="label info green" *ngIf="savePolicyStatus === 'success'">
        Policies were updated!
      </div>

      <div class="label info red" *ngIf="savePolicyStatus === 'error'">
        Something went wrong, please try again!
      </div>

    </div>
  </div>

</div>
